export default "__VITE_ASSET__r80b$gb4__"